/** Fila mínima de `inventory.stocks` para resolver el alcance del historial. */
export type StockScopeRow = { id: string; variant_id?: string | null };

/**
 * IDs de filas de `inventory.stocks` cuyos movimientos corresponden a la celda consultada.
 * - Celda de variante (`variantId` definido): solo la fila de esa variante.
 * - Fila de producto (parent/agrupada, `variantId` null): todas las filas del
 *   producto en la sucursal, así el historial incluye los movimientos de cada variante.
 */
export function selectStockIdsForMovementHistory(
  rows: StockScopeRow[],
  variantId: string | null | undefined
): string[] {
  const scope = variantId ? rows.filter((r) => r.variant_id === variantId) : rows;
  return scope.map((r) => r.id).filter((id): id is string => typeof id === 'string' && id.length > 0);
}
